import { useState } from 'react'
import * as graph from '@adc/sdk'
import classnames from 'classnames/bind'
import { RadioItem, Text, Icon, utils } from '@adc/ui-adc'
import { ColorNames } from '@adc/ui-core/lib/types/constants'
import styles from './styles.scss'
const cx = classnames.bind(styles)
const { getCssColorFromColorName } = utils.colors

interface IntentRadioProps {
  isSelected: boolean
  onClick: () => void
  items: string[]
  title: string
  tooltipColor?: ColorNames | 'combined'
  tooltip: string
  icon: string
  elmId: string
  index: number
}

export const IntentRadio = ({
  isSelected,
  onClick,
  items,
  title,
  tooltipColor = 'combined',
  tooltip,
  icon,
  elmId,
  index,
}: IntentRadioProps) => {
  const shouldDisplayCombinedColor = tooltipColor === 'combined'
  const style: {
    backgroundColor?: string
  } = {}
  if (tooltipColor && !shouldDisplayCombinedColor) {
    style.backgroundColor = getCssColorFromColorName(tooltipColor)
  }

  return (
    <div
      className={cx('option-container')}
      data-elm-id={`option-container-${index}`}
    >
      <div
        className={cx('option-tooltip', {
          'combined-color': shouldDisplayCombinedColor,
        })}
        style={style}
      >
        <Text
          color='white'
          size='tiny'
          weight='heavy'
          style={{ whiteSpace: 'nowrap' }}
          elmId={`option-tooltip-${index}`}
        >
          {tooltip}
        </Text>
        <Icon name={icon} iconStyle='regular' color='white' />
      </div>
      <div className={cx('option-title')} data-elm-id={`option-title-${index}`}>
        <Text color='grayDark' weight='heavy' size='huge'>
          {title}
        </Text>
        <RadioItem
          onChange={onClick}
          checked={isSelected}
          data-elm-id={`${elmId}_checkbox_${index}`}
          className={cx('radio-item')}
        />
      </div>

      <div className={cx('option-body')} data-elm-id={`option-body-${index}`}>
        {items.map((item, index) => (
          <div key={index} className={cx('option')}>
            <Icon name='check' color='adcLightBlue' style={{ fontSize: 20 }} />
            {item}
          </div>
        ))}
      </div>
    </div>
  )
}

export type IntentValueType = typeof graph.enums.SellerIntentType
export interface IntentOptionsType {
  title: string
  tooltip: string
  tooltipColor?: typeof ColorNames | 'combined'
  icon: string
  items: string[]
  value: string
}

export interface IntentSelectorPropsType {
  elmId: string
  value?: string
  name: string
  onChange: (e: any, { value }: { value: string }) => void
  options?: any[]
}

const IntentSelector = ({
  elmId,
  value,
  onChange,
  options,
}: IntentSelectorPropsType) => {
  const [selectedIntent, setSelectedIntent] = useState<string | undefined>(
    value
  )

  const onSelectIntent = (value: string) => {
    setSelectedIntent(value)
    onChange(null, { value })
  }
  return (
    <div className={cx('intent-containers')} data-elm-id={elmId}>
      {options?.map((option, index) => (
        <IntentRadio
          isSelected={selectedIntent === option.value}
          onClick={() => onSelectIntent(option.value)}
          items={option.items}
          title={option.title}
          tooltipColor={option.tooltipColor}
          tooltip={option.tooltip}
          icon={option.icon}
          elmId={`${elmId}_select`}
          index={index}
        />
      ))}
    </div>
  )
}

export default IntentSelector
